/**
 * A Test helper that sets react query keys for use in cypress, especially useful for tests where the key changees often.
 *
 * # Note
 *
 * Ensure this key is same as used in your tests.
 */
export function cyRQKeyHelper(localStorageId: string, qKey: string[]) {
  if (window.Cypress) {
    localStorage.setItem(localStorageId, JSON.stringify(qKey));
  }
}
